<template>
  <div class="Terminal">
    <div class="btn-list" >
      <van-button v-for="(item, index) in titelData"
                  :key="index" :name="index"
                  :class="['terminal-btn', { 'selected': selectedIndex === index }]"
                  icon="/static/images/etv-folder.png"
                  @click="getChea(index)">
        {{ truncatedName(item.name) }}
      </van-button>
    </div>
    <div class="content abcds" ref="scrollContainer">
      <div class="scroll-a" v-if="data.length>0">
        <div v-for="(it, i) in data"
             :key="i"
             class="custom-checkbox">
          <van-cell class="checkbox-content"
                    :icon="it.onlineState == '1' ? '/static/images/terminal/icon_dev_online.png' : '/static/images/terminal/icon_dev_disonline.png'">
            <div class="ellipsis">
              <span class="name">{{ it.name }} </span>
              <span style="float: right;">
              <van-icon  style="margin-right:10px "  name="/static/images/terminal/del.png" @click="deleTer(it.clNo, i)" />
              <van-icon style="margin-right:10px " name="/static/images/terminal/view.png"  @click="gotoView(it)" />
              <van-icon name="/static/images/terminal/exit.png"  @click="goto(it)" />
            </span>
            </div>

          </van-cell>
        </div>
      </div>
      <van-empty
          v-else
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.data_empty')"
      />
    </div>
    <div class="btns">
      <div>
        <van-button color="#006EFF" size="small" @click="reload">{{$t('append_field.refresh')}}</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#006EFF" size="small" @click="$router.push({path: '/deviceListManagement'})">{{$t('append_field.group_management')}}</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <!-- <van-button color="#409eff" size="small" @click="scan">{{$t('append_field.device_access')}}</van-button>-->
      </div>
      <div>
        <van-button color="#006EFF"  size="small" @click="open" >{{$t('append_field.filter')}}</van-button>
      </div>
    </div>
    <van-dialog v-model="dialogShow"
                :title="$t('append_field.create_terminal_group')"
                show-cancel-button
                @confirm="onsubmit"
                class="edit-dialog"
                :beforeClose="vBeforeClose"
                @cancel="inputDialogClose">
      <van-field v-model="groupName"
                 :label="$t('append_field.name')"
                 :placeholder="$t('append_field.ps_push_name')"
                 clearable
                 style="margin: 40px 0"/>
    </van-dialog>
    <!--          编辑设备名称弹窗-->
    <van-dialog
        v-model="showEditDialog"
        :title="$t('append_field.edit_device_name')"
        show-cancel-button
        class="edit-dialog"
        :beforeClose="vBeforeClose"
        @confirm="submitEdit"
        @cancel="cancelEdit"
    >

      <van-row >
        <van-field
            v-model="editValue" :label="$t('append_field.name')" clearable :placeholder="$t('append_field.enter_device_name')"
            style="background: #FFFFFF;
                   margin: 40px 0;
                ">
        </van-field>
      </van-row>
    </van-dialog>
    <!-- 筛选弹窗   -->
    <van-dialog
        v-model="show"
        :title="$t('append_field.filter')"
        show-cancel-button
        :beforeClose="vBeforeClose"
        @confirm="onSearch"
        @cancel="close"
    >
      <van-search
          v-model="clientName"
          :placeholder="$t('append_field.enter_search_keyword')"
          shape="round"
          @search="onSearch"
      >
      </van-search>
      <div class="popup-title">{{$t('append_field.terminal_status')}}</div>
      <div class="popup-btns">
        <van-radio-group v-model="selectedType">
          <van-cell-group>
            <van-cell
                v-for="(item, index) in typeOptions"
                clickable
                :key="index"
                @click="getType(item.value)"
                :title="item.label"
            >
              <template #right-icon>
                <van-radio :name="item.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>
    <!--  预览设备信息弹窗  -->
    <div v-if="showView" class="view-overlay">
      <div class="view">
        <div class="view-header">
          <h3 class="view-title">{{ $t('append_field.device_info') }}</h3>
        </div>
        <div class="view-body">
          <van-cell :value="clientInfo.clName">
            <template #title>
              <div class="cell-title">{{$t('append_field.device_name')}}</div>
            </template>
          </van-cell>
          <van-cell :value="clientInfo.clIp">
            <template #title>
              <div class="cell-title">{{$t('append_field.device_ip')}}</div>
            </template>
          </van-cell>
          <van-cell :value="clientInfo.clMac">
            <template #title>
              <div class="cell-title">{{$t('append_field.device_mac')}}</div>
            </template>
          </van-cell>
          <van-cell :value="clientInfo.clNo">
            <template #title>
              <div class="cell-title">{{$t('append_field.device')}}</div>
            </template>
          </van-cell>
          <van-cell :value="clientInfo.clResolution">
            <template #title>
              <div class="cell-title">{{$t('append_field.resolution_')}}</div>
            </template>
          </van-cell>
          <van-cell :value="clientInfo.clDisk">
            <template #title>
              <div class="cell-title">{{$t('append_field.device_memory')}}</div>
            </template>
          </van-cell>
          <van-cell :value="clientInfo.clVersion">
            <template #title>
              <div class="cell-title">{{$t('append_field.system_version')}}</div>
            </template>
          </van-cell>
        </div>
        <div class="view-footer">
          <van-button style="color: black;border-top: 1px solid #B8B8B8;"  @click="showView=false">{{ $t('append_field.close') }}</van-button>
      </div>
    </div>
    </div>
    <van-overlay :show="overlayShow">
      <div class="wrapper">
            <span class="close" @click="overlayShow = false">
              <van-icon name="cross"/>
            </span>
        <van-loading size="40px">{{$t('append_field.call_device_please_wait')}}</van-loading>
      </div>
    </van-overlay>
    <van-overlay :show="showLoading">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading  size="40px" vertical >{{ msg }}...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Toast} from 'vant'
import {mapActions} from 'vuex'
import {vBeforeClose} from "@/utils/tool";

export default {
  name: 'Terminal',
  inject: ['reload'],
  data() {
    return {
      activeNames: '',
      data: [],
      titelData: [],
      TerminalTop: 0,
      dataList: [],
      doch: 0,
      loading: false,
      finished: false,
      index: 0,
      dialogShow: false,
      groupName: '',
      show: false,
      onlineState: '',
      clientName: '',
      a: 1,
      timeOutEvent: 0,
      longClick: 0,
      deviceNo: '',
      programgroupName: '',
      deviceName: '',
      showPicker: false,
      programShow: false,
      groupingList: [],
      qrCodeData: {
        code: 'dasdsadsd',
      },
      programNameIndex: 0,
      overlayShow: false,
      showLoading: true,
      msg:this.$t('append_field.loadingb'),
      selectedIndex:0,
      typeOptions: [
        { value: '0', label: this.$t('append_field.all') },
        { value: '1', label: this.$t('append_field.online') },
        { value: '-1', label: this.$t('append_field.offline') },
      ],
      selectedType:'0',
      showEditDialog:false,
      editValue: '', // 绑定到输入字段的数据
      showView:false,//预览设备信息弹窗
      clientInfo:[]
    }
  },

  mounted() {
    document.title = this.$t('append_field.terminal_management')
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.doch = window.screen.height
    const scrollContainer = document.getElementsByClassName('abcds')[0]
    scrollContainer.addEventListener('scroll', this.handleScroll2);
    this.showLoading=true
    this.getData()

  },
  methods: {
    vBeforeClose,
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),

    handleResize() {
      // 获取底部导航栏元素
      const tabbar = document.querySelector('.van-tabbar')
      tabbar.style.display = ''
    },
    gotouchstart(item, index) {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
      this.longClick = 0
      //默认分组不可删除
      if (item.id === "1") {
        return
      }

      this.timeOutEvent = setTimeout(() => {
        this.longClick = 1
        Dialog.confirm({
          title: this.$t('append_field.delete_group'),
          message: this.$t('append_field.confirm_delete_group'),
        }).then(() => {
          this.$ajax.post('/etv/deleteGroupById.json', qs.stringify({
            id: item.id,
          })).then(res => {
            if (res.data.code === 0) {
              Toast(this.$t('append_field.delete_success'))
              this.titelData.splice(index, 1)
            }
            Toast(res.data.msg)
          })
        }).catch(() => {
        })

      }, 700)//这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend() {
      clearTimeout(this.timeOutEvent)

    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove() {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
    },
    getChea(index) {
      this.index = 0
      if (index === '') {
        return
      }
      this.selectedIndex = index
      //重置滚动位置
      this.$refs.scrollContainer.scrollTop = 0
      this.activeNames = index
      const locale = navigator.language || 'zh-Hans-CN';
      const chineseNumbers = {
        "一": 1,
        "二": 2,
        "三": 3,
        "四": 4,
        "五": 5,
        "六": 6,
        "七": 7,
        "八": 8,
        "九": 9,
      };
      function convertChineseNumbers(str) {
        return str.replace(/(?<!\d)([一二三四五六七八九])(?!\d)/g, char => chineseNumbers[char]);
      }

      function naturalCompare(a, b) {
        const collator = new Intl.Collator(locale, { numeric: true, sensitivity: 'accent' });
        return collator.compare(a, b);
      }
      function sortNodesByName(nodes) {
        return nodes.sort((a, b) => {
          // 转换中文数字
          const nameA = convertChineseNumbers(a.name.replace(/\s+/g, ''))
          const nameB = convertChineseNumbers(b.name.replace(/\s+/g, ''))

          // 自然排序
          const naturalOrder = naturalCompare(nameA, nameB);
          if (naturalOrder !== 0) {
            return naturalOrder;
          }

          // 如果自然排序结果相同，进行拼音排序
          for (let i = 0; i < Math.min(nameA.length, nameB.length); i++) {
            const charA = nameA.charAt(i);
            const charB = nameB.charAt(i);

            if (charA !== charB) {
              const lowerA = charA.toLowerCase();
              const lowerB = charB.toLowerCase();

              if (lowerA === lowerB) {
                // 如果字符相同但大小写不同，区分大小写
                return charA < charB ? -1 : 1;
              } else {
                // 如果字符不同，按字符顺序排序
                return lowerA < lowerB ? -1 : 1;
              }
            }
          }

          // 最后，如果前面的排序都相同，使用 localeCompare 进行最终比较
          return a.name.localeCompare(b.name, locale, { sensitivity: 'accent' });
        });
      }
      const data = sortNodesByName(this.dataList[this.activeNames].children)
      this.data = data.slice(this.index,this.index + 15)
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },
    onprogramShow() {
      let str = this.qrCodeData.code
      if (!this.groupingList[this.programNameIndex].id) {
        Toast(this.$t('append_field.pel_select_group'))
        return
      }

      if (this.deviceName === '') {
        Toast(this.$t('append_field.enter_device_name'))
        return
      }

      this.$ajax.post('/etv/insertPhoneClient.json', qs.stringify({
        clName: this.deviceName,
        clNo: str,
        clGpId: this.groupingList[this.programNameIndex].id,
      })).then(res => {
        this.showPicker = false
        this.programShow = false
        if (res.data.code === 0) {
          Toast(this.$t('append_field.add_success'))
        } else {
          Toast(res.data.msg)
        }
      })
    },
    getData(onlineState = '', clientName = '', groupParentId = '', type = '') {
      this.msg = this.$t('append_field.loadingb')
      this.$ajax.post('/etv/selectSeachClientTreeMobile.json', qs.stringify({
        groupParentId,
        type,
        onlineState,
        clientName,
      })).then(res => {
        this.titelData = []
        this.dataList = []
        if (res.data.code === 0) {
          res.data.data.map((res) => {
            this.titelData.push({id: res.id, name: res.name})
          })
          this.dataList = res.data.data
          // 默认加载第一个按钮的设备列表
          if(this.index === -1) this.index = 0
          this.activeNames=this.activeNames?this.activeNames:0
          if(this.dataList.length !== 0 ){
            this.data = this.dataList[this.activeNames].children.slice(this.index, this.index + 15)
          }else {
            this.data=[]
          }

          this.$nextTick(() => {
            this.showLoading = false
          })
        }
      })
    },
    onConfirm(value, index) {
      this.showPicker = false
      this.programgroupName = value
      this.programNameIndex = index
    },
    handleScroll2() {
      const scrollHeight = document.getElementsByClassName('content')[0].scrollTop;
      const clientHeight = document.getElementsByClassName('abcds')[0].clientHeight;
      const doch = document.getElementsByClassName('content')[0].clientHeight;

      if (clientHeight - doch - scrollHeight < 10) {

        const children = this.dataList[this.activeNames].children
        if (children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data = [...new Set([...this.data, ...children.slice(this.index * 15, this.index * 15 + 15)])];
      }
    },

    deleTer(clNo, index) {
      Dialog.confirm({
        title: this.$t('append_field.delete_device'),
        message: this.$t('append_field.confirm_delete_device'),
      }).then(() => {
        this.$ajax.post('/etv/deleteClientByClNo.json', qs.stringify({
          clNos: clNo,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.delete_success'))
            this.data.splice(index, 1)
          }
        })
      }).catch(() => {

      })
    },

    goto(data) {
      this.showEditDialog = true
      this.editValue=data.name
      this.id=data.clId
    },
    gotoView(data){
      this.getClientInfo(data.clId)
      this.showView=true
    },
    getClientInfo(id) {
      this.$ajax.post('/etv/selectClientByClId.json', qs.stringify({
        id: id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientInfo = res.data.data.clientInfo

        }else {
          Toast(res.data.msg)
        }
      })

    },
    onsubmit() {
      this.$ajax.post('/etv/insertGroup.json', qs.stringify({
        groupName: this.groupName,
        groupParentId: -1,
        groupDescp: '',
      })).then(res => {
        if (res.data.code === 0) {
          this.reload()
        } else {
          Toast(res.data.msg)
        }
      })
    },

    getContainer() {
      return document.querySelector('.Terminal')
    },

    onSearch() {
      this.getData(this.onlineState, this.clientName)
      this.show = false
    },

    open() {
      this.show = true
    },

    close() {
      this.show = false
      this.inputDialogClose()
    },

    getType(type) {
      this.selectedType=type
      this.onlineState = type
    },
    inputDialogClose() {
      console.log(159);
      this.dialogShow = false
      this.show = false
      this.groupName = ''
    },
    //编辑设备名称
    cancelEdit(){
      this.showEditDialog = false
    },
    submitEdit() {
      // 这里提交编辑后的值
      let editValue=this.editValue
      // 这里可以添加提交到服务器的代码
      this.$ajax.post('/etv/updateClientNameOrGroupName.json', qs.stringify({
        id: this.id,
        name: editValue,
        type: "client"
      })).then(res => {
        if (res.data.code === 0) {
          Toast(res.data.msg,'success' )
          this.reload()
        }else {
          Toast(res.data.msg,'fail')
        }
        this.showEditDialog = false
      })


    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.Terminal {

  height: 100% !important;
  overflow:hidden;
  .van-field{
    .van-field__label{
      width: 60px;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /*height: calc(100% - 70px);*/
    position: relative;

    .close {
      top: 10px;
      right: 10px;
      position: absolute;

      i {
        color: white;
      }
    }
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  .btn-list{
    display: flex;
    overflow-x: auto; /* 水平滚动 */
    align-items: center;
    justify-content: flex-start;
    gap: 10px; /* 按钮之间的间隔 */
    height: 60px;
    border-bottom: 1px solid #707070;
    .van-icon__image{
      height:20px;
      width: 20px;
    }
    .terminal-btn{
      background-color: white;
      color: black;
      border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
    }
    .van-button__text{
      display: block;
      max-width: 100%;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }
    .selected {
      background-color: #006EFF ;
      color: white;
    }
  }
  .content {
    height: calc(100% - 60px - 60px - 70px);
    overflow-y: auto; /* 水平滚动 */
    .van-cell{
      padding: 10px 10px 0 10px;
    }
    .checkbox-content {
      display: flex;
      align-items: center;
      .ellipsis {
        width: 100%; /* 根据需要调整宽度 */
        display: flex;
        justify-content: space-between; /* 水平分布子元素 */
        align-items: center; /* 垂直居中对齐子元素 */
        .name{
          display: block;
          max-width: 130px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .van-cell__left-icon{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .van-icon__image{
        width: 40px;
        height: 40px;
      }
    }

    .van-collapse-item__title--expanded {
      background: $uni-color-primary;
      color: #ffffff;
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

    }


  }

  .btns {
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;

  }

  .a {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }

  .button-btns {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .van-button--mini {
    font-size:  16px;
    height: 30px;
    box-sizing: border-box;
  }


  .van-cell__right-icon {
    color: white;
    line-height: 30px !important;
  }

  .van-cell__left-icon, .van-cell__right-icon {
    height: 30px;
    font-size: 16px !important;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }
  .edit-dialog{
    .van-field__body{
      border-bottom: black 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }

  }
  .view-overlay{
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .view {
    background: #fff;
    border-radius: 4px ;
    width: 100%;
  }
  .view-header {
    display: flex;
    padding: 12px 20px ;
    justify-content: center;
    align-items: center;
    background: #F2F2F2 !important;
  }

  .view-title {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
  }
  .view-body .van-cell {
    display: block;
   /* padding: 0 16px;*/
  }

  .view-body .van-cell__value {
    text-align: left;
    color: black;
    width: 100%; /* 使文本占满按钮宽度 */
    white-space: nowrap; /* 确保文本在一行显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
  }


  .view-footer {
    display: flex;
    justify-content: space-between;

    background: #F2F2F2 ;
    .van-button {
      height: 48px !important;
      background: #F2F2F2 ;
      border-radius: 0 !important;
      flex: 1;
    }
  }
}
</style>
